var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

$(document).ready(function () {
    var loc = getUrlParameter("loc");
    if (loc === "uk") {
        jQuery(".more-details").hide();
    }

    $.urlParam = function (name) {
        var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
            window.location.href
        );
        if (results == null) {
            return null;
        }
        return decodeURI(results[1]) || 0;
    };

    var e = {
        ".one-bottle": {
            id: ".one-bottle",
            quantity: "One Bottle",
            frequency: 30,
            freq: 1,
            vid: "44334343258349",
        },
        ".two-bottle": {
            id: ".two-bottle",
            quantity: "Two Bottles",
            frequency: 60,
            freq: 2,
            vid: "44334343291117",
        },
        ".four-bottle": {
            id: ".four-bottle",
            quantity: "Four Bottles",
            frequency: 120,
            freq: 4,
            vid: "44334343323885",
        },
    };

    for (var t in e) {
        $(t).attr("data-id", t);
        $(t).click(function () {
            console.log("click");
            var t = $(this).attr("data-id"),
                o = e[t];
            $("#subscription .quant").html("Quantity: " + o.quantity);
            $("#subscription .freq").html(
                "Frequency: Every " + o.frequency + " Days"
            );
            $("#subscription a.no").attr("data-id", o.id);
            $("#subscription a.yes").attr("data-id", o.id);
            $("#subscription").modal({
                escapeClose: !1,
                clickClose: !1,
                showClose: !1,
            });
        });
    }

    // YES click handler - from second file (working version)
    $("#subscription a.yes").click(function () {
        var t = $(this).attr("data-id"),
            o = e[t];
        console.log(o);
        $('#productSelect option[value="' + o.vid + '"]').prop("selected", !0);
        var r = new Event("change");
        $("#productSelect").get(0).dispatchEvent(r);
        $("#productSelect").change();
        setTimeout(function () {
            $(".bold-ro__recurring-div .bold-ro__recurring-lbl").click();
            setTimeout(function () {
                $(".bold-ro__frequency-num").val(o.freq);
                $(".bold-ro__frequency-num option[value='" + o.freq + "']").attr(
                    "selected",
                    "selected"
                );
                $(".bold-ro__frequency-num option[value='" + o.freq + "']")
                    .prop("selected", !0)
                    .change();
                setTimeout(function () {
                    console.log($(".bold-ro__recurring-div"));
                    console.log($(".bold-ro__frequency-num").val());
                    $("#AddToCart").click();
                }, 50);
            }, 50);
        }, 50);
    });

    // NO click handler - from second file (working version)
    $("#subscription a.no").click(function (event) {
        event.preventDefault();
        $("#subscription").modal("close");
        $("#subscription").hide();

        var t = $(this).attr("data-id"),
            o = e[t];

        console.log("NO subscription - adding to cart:", o);

        // Select the correct product variant
        $('#productSelect option[value="' + o.vid + '"]').prop("selected", true);

        // Dispatch change event
        var r = new Event("change");
        $("#productSelect").get(0).dispatchEvent(r);
        $("#productSelect").change();

        // Force one-time purchase by clearing any subscription data
        setTimeout(function () {
            // Clear subscription selections
            $('input[name="selling_plan"]').val('');
            $('select[name="selling_plan"]').val('').trigger('change');
            
            // If there's a one-time button, click it
            if ($(".bold-ro__one-time-div").length) {
                $(".bold-ro__one-time-div").click();
            }
            
            $("#AddToCart").click();
        }, 50);
    });

    $(".header-menu li.has-child-menu").each(function () {
        $(this)
            .find("a")
            .first()
            .append(
                '<span class="open-submenu"><i class="fas fa-angle-down"></i></span>'
            );
    });

    $(".bundle-save .products").slick({
        slidesToShow: 1,
        infinite: true,
        arrows: false,
        dots: true,
        initialSlide: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    dots: false,
                },
            },
        ],
    });

    $(".product .select .active").click(function () {
        $(".product .select ul").toggle(0);
    });

    $(".bold-ro__frequency-type.bold-ro__order-interval").val(3);
    $(".bold-ro__frequency-type.bold-ro__order-interval option[value='3']").attr(
        "selected",
        "selected"
    );
    $(".bold-ro__frequency-type.bold-ro__order-interval option[value='3']")
        .prop("selected", true)
        .change();

    var defaultVarTxt = $("#AddToCartForm .select .active").text();
    var defaultPrice = defaultVarTxt.split("$")[1];
    var noUsdDefaultPrice = defaultPrice.replace("USD", " ");

    var currentOneTimeTxt = $(".bold-ro__one-time-purchase").text();

    var updatedOneTimeTxt = "$" + noUsdDefaultPrice;
    
    if ($(".ro_widget").length && $("#bold-widget").length) {
        var discount = $(".bsub-widget__group-discount-summary")
            .text()
            .replace("(Save ", "")
            .replace(")", "");
        var price = $(
            ".bsub-widget__plan-pricing span[data-bsub-per-delivery-price]"
        )
            .eq(0)
            .text();
        $(".bold-ro__initial-discount-percent").text(discount);
        $(".bold-ro__initial-discount-price").text(price);

        if ($(".ro_widget .bold-ro__one-time-radio-btn").is(":checked")) {
            $(
                '#bold-widget input[name="bsub-selling-plan-group"][value="once"]'
            ).click();
        }

        if ($(".ro_widget .bold-ro__subscribe-radio-btn").is(":checked")) {
            $(
                '#bold-widget input[name="bsub-selling-plan-group"]:not([value="once"])'
            ).click();
        }
    }

    $(".ro_widget .bold-ro__one-time-radio-btn").change(function (event) {
        if ($(this).is(":checked")) {
            $(
                '#bold-widget input[name="bsub-selling-plan-group"][value="once"]'
            ).click();
        }
    });

    $(".ro_widget .bold-ro__subscribe-radio-btn").change(function (event) {
        if ($(this).is(":checked")) {
            $(
                '#bold-widget input[name="bsub-selling-plan-group"]:not([value="once"])'
            ).click();
        }
    });

    $(".product .select li").click(function () {
        var active = $(".product .active");
        var activeText = active.text();
        var activeId = active.data("id");
        active.html($(this).text());

        var selectedPrice = $(this).text().split("$")[1];
        var noUsdSelectedPrice = selectedPrice.replace("USD", " ");
        var replacedOneTimeTxt = "$" + noUsdSelectedPrice + " One-time purchase";
        $(".bold-ro__one-time-purchase").text(replacedOneTimeTxt);

        active.data("id", $(this).data("id"));
        $('#productSelect option[value="' + $(this).data("id") + '"]').prop(
            "selected", 
            true
        );
        var event = new Event("change");
        $("#productSelect").get(0).dispatchEvent(event);
        $("#productSelect").change();
        $(this).html(activeText);
        $(this).data("id", activeId);
        $(".product ul").hide(0);
    });

    $(".bold-ro__recurring-div").addClass("red-btn");
    $(".bold-ro__one-time-div").addClass("transparent-btn");

    $(document).on("click", ".bold-ro__one-time-purchase", function () {
        $(".bold-ro__one-time-div").addClass("red-btn");
        $(".bold-ro__one-time-div").removeClass("transparent-btn");
        $(".bold-ro__recurring-div").addClass("transparent-btn");
        $(".bold-ro__recurring-div").removeClass("red-btn");
    });

    $(document).on("click", ".bold-ro__recurring-text", function () {
        $(".bold-ro__one-time-div").removeClass("red-btn");
        $(".bold-ro__one-time-div").addClass("transparent-btn");
        $(".bold-ro__recurring-div").removeClass("transparent-btn");
        $(".bold-ro__recurring-div").addClass("red-btn");
        var active = $(".product .active");
        var activeText = active.text();
        if (document.getElementById('subscribe-save').checked) {
            console.log(activeText);
            console.log(activeText.includes("Single"));
            if (activeText.includes("Single")) {
                $(".bold-ro__frequency-num").val(1);
                $(".bold-ro__frequency-num option[value='1']").attr(
                    "selected",
                    "selected"
                );
                $(".bold-ro__frequency-num option[value='1']")
                    .prop("selected", true)
                    .change();
            } else if (activeText.includes("2")) {
                $(".bold-ro__frequency-num").val(2);
                $(".bold-ro__frequency-num option[value='2']").attr(
                    "selected",
                    "selected"
                );
                $(".bold-ro__frequency-num option[value='2']")
                    .prop("selected", true)
                    .change();
            } else if (activeText.includes("4")) {
                $(".bold-ro__frequency-num").val(4);
                $(".bold-ro__frequency-num option[value='4']").attr(
                    "selected",
                    "selected"
                );
                $(".bold-ro__frequency-num option[value='4']")
                    .prop("selected", true)
                    .change();
            }

            $(".bold-ro__frequency-type.bold-ro__order-interval").val(3);
            $(
                ".bold-ro__frequency-type.bold-ro__order-interval option[value='3']"
            ).attr("selected", "selected");
            $(".bold-ro__frequency-type.bold-ro__order-interval option[value='3']")
                .prop("selected", true)
                .change();
        }
    });

    $(".dropdown-item").click(function () {
        $(this).toggleClass("opened");
        $(this).find(".text").slideToggle(300);
        $(this).siblings(".dropdown-item").removeClass("opened");
        $(this).siblings(".dropdown-item").find(".text").slideUp(300);
    });

    const currentURL = window.location.href;
    const lastSlashIndex = currentURL.lastIndexOf("/");
    const lastSegment = currentURL.substring(lastSlashIndex + 1);
    const containsLollipop = lastSegment.includes("lollipop");
    if ($("section.hero").length > 0) {
        if (containsLollipop == true) $("section.hero").addClass("overflow");
    }
});